
import "./Projects.css";

const PROJECTS = [
{
  title: "Yentema Art Salon",
  desc: "A modern, mobile-first salon website built to showcase services, barbers, gallery work, and easy booking. Designed for a clean, professional brand presence and a smooth client experience.",
  tags: ["Client Work", "Web Design", "Responsive", "Branding"],
  live: "https://www.yentemaartsalon.com/",
  code: null, // client project (private)
  image: "/assets/yentema-art-salon.png",
  overlayDark: "rgba(18, 94, 160, 0.92)",   // deep blue overlay
  overlayLight: "rgba(18, 94, 160, 0.14)",  // soft tint
},
   {
    title: "Play Therapy Practice",
    desc:
      "I create a warm, supportive environment to help children and families build emotional regulation, social skills, self-confidence, and healthy communication through a relationship-centered approach.",
    tags: ["React", "UI/UX", "Responsive", "Client Work"],
    live: "https://www.summersheridanzabrelcsw.com/",
    code: null, // private client project
    image: "/assets/therapy-site.png",
    overlayDark: "rgba(84, 132, 110, 0.92)",   // calm green
    overlayLight: "rgba(84, 132, 110, 0.14)",
  },
{
  title: "Birthday Party Site",
  desc:
    "Interactive event website built with React featuring RSVP functionality, guest tracking, and a clean, mobile-first design for real-world use.",
  tags: ["React", "Firebase", "UI", "Responsive"],
  live: "https://bithday-party-site.web.app/",
  code: "https://github.com/zabroski/birthday-party-site", // update if repo name differs
  image: "/assets/birthday-party.png",
  overlayDark: "rgba(255, 99, 132, 0.92)",   // celebratory pink/red
  overlayLight: "rgba(255, 99, 132, 0.14)",
},

  // {
  //   title: "Face Recognition App",
  //   desc: "Full-stack app using React, Node/Express, and PostgreSQL.",
  //   tags: ["React", "Node", "PostgreSQL"],
  //   live: "https://smart-skill.herokuapp.com/",
  //   code: "https://github.com/zabroski/face-recognition-app",
  //   image: "/assets/face.png",
  //   overlayDark: "rgba(46, 229, 157, 0.92)",
  //   overlayLight: "rgba(46, 229, 157, 0.14)",
  // },
  {
    title: "Robot Friends",
    desc: "Interactive React app, showcases dynamic UI rendering, component-based architecture, and real-time data filtering. It fetches user data from an API and displays it as visually styled “robot cards,” enabling instant search and filtering.",
    tags: ["React", "UI", "Responsive"],
    live: "http://robot-friendsn.surge.sh/",
    code: "https://github.com/zabroski/robots",
    image: "/assets/robot.jpg",
    overlayDark: "rgba(0, 173, 181, 0.92)",
    overlayLight: "rgba(0, 173, 181, 0.14)",
  },
  {
    title: "Joke API",
    desc: "A fun, interactive React app that generates random jokes on demand. It showcases third-party API integration, asynchronous data fetching, responsive UI design, and state management in a simple, engaging user experience.",
    tags: ["JavaScript", "API", "UI"],
    live: "https://zabroski.github.io/joke-api-app/",
    code: "https://github.com/zabroski/joke-api-app",
    image: "/assets/joke.jpg",
    overlayDark: "rgba(255, 184, 0, 0.92)",
    overlayLight: "rgba(255, 184, 0, 0.16)",
  },  

   {
    title: "Burger Builder",
    desc: "A responsive React app for building custom burgers, using Redux for state management and Firebase for order persistence.",
    tags: ["React", "Redux", "Firebase"],
    live: "https://react-my-burger-82791.web.app/",
    code: "https://github.com/zabroski/burger-app",
    image: "/assets/burger.png",
    overlayDark: "rgba(124, 92, 255, 0.92)",   // dark theme overlay
    overlayLight: "rgba(92, 76, 255, 0.14)",   // light theme overlay (soft tint)
  },
];


export default function Projects() {
  return (
    <section id="projects" className="section section--alt">
      <div className="container">
        <div className="sectionHeader">
          <h2 className="sectionTitle">Projects</h2>
          <p className="sectionSubtitle">
            Selected work spanning client websites, interactive applications, and production-ready React builds.
          </p>
        </div>

        <div className="projectsGrid">
          {PROJECTS.map((p) => (
            <article
              key={p.title}
              className="projectCard"
              style={{
                "--overlay-dark": p.overlayDark,
                "--overlay-light": p.overlayLight,
              }}
            >
              <div className="projectCard__media">
                <img
                  src={p.image}
                  alt={`${p.title} preview`}
                  className="projectCard__img"
                  loading="lazy"
                />

                <div className="projectCard__overlay">
                  <h3 className="projectCard__title">{p.title}</h3>
                  <p className="projectCard__desc">{p.desc}</p>

                  <div className="projectCard__tags">
                    {p.tags.map((t) => (
                      <span key={t} className="tag">
                        {t}
                      </span>
                    ))}
                  </div>

                  <div className="projectCard__actions">
                    <a
                      className="btn btn--primary"
                      href={p.live}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Live
                    </a>

                    {p.code && (
                      <a
                        className="btn btn--ghost"
                        href={p.code}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Code
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
